export const FIELDS = {
  ID: 'id',
  ACCOUNT_NAME: 'accountName',
  ACCOUNT_TYPE_ID: 'accountTypeId',
  ACCOUNT_TYPE: 'accountType',
  DESCRIPTION: 'description',
  ACCOUNT_NO: 'accountNo',
  TAX_LINE: 'taxLine',
  SUB_ACCOUNT: 'subAccount',
  SUB_ACCOUNT_OF: 'subAccountOf',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  PHONE: 'phone',
  FAX: 'fax',
  GLACCOUNT_NO: 'glAccountNo',
  BALANCE: 'balance',
  TOTAL: 'total',
  CURRENCY: 'currency',
  SYMBOL: 'symbol',
  QBACCOUNT_LIST_ID: 'qbAccountListId',
  QBO_ACCOUNT_NAME: 'qboAccountName',
  QBO_ACCOUNT_SUB_TYPE: 'qboAccountSubType',
  QBO_ITEM_ID: 'qboItemId',
  QBO_ITEM_NAME: 'qboItemName',
  QBSYNCED: 'qbSynced',
  ACTIVE: 'active',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',};

  export const ACCOUNT_TYPES = {
    "Accounts Payable": 1,
    "Accounts Receivable": 2,
    "Bank": 3,
    "Cost of Goods Sold": 4,
    "Credit Card": 5,
    "Equity": 6,
    "Expense": 7,
    "Fixed Asset": 8,
    "Income": 9,
    "Long Term Liability": 10,
    "Non Posting": 11,
    "Other Current Asset": 12,
    "Other Current Liability": 13,
    "Other Expense": 14,
    "Other Income": 15,
  }
  
  export const QBO_ACCOUNTS = {
    "Shipping & handling": 1,
    "Inspection": 2,
    "Banking": 3,
  }